import { register, mount } from 'riot'
import MobileDetect from 'mobile-detect'
import FavButton from 'tags/favbutton.riot'

const initializeFavbutton = () => {
  register('favbutton', FavButton)

  const md = new MobileDetect(window.navigator.userAgent)
  const isMobile = !!(md.phone())
  const FavoriteLoader = require('loaders/favorite_loader.js')
  const loader = new FavoriteLoader()
  loader.fetchFavorites(()=>{
    mount('favbutton', { loader: loader, mobile: isMobile })
  })
}

if (document.readyState !== "loading") {
  initializeFavbutton()
} else {
  document.addEventListener('DOMContentLoaded', initializeFavbutton)
}
